angular.module('core')
  .service('studentAlertsApi', [
        'cancelableResourceFactory',
        'cancelableResourceManager',
    function (
        cancelableResourceFactory,
        cancelableResourceManager
    ) {
    this.getStudentAlerts = getStudentAlerts;

    var StudentAlerts = cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/alerts', {}, {
        get: {
            method: 'GET',
            isArray: false,
            cache: false,
            transformResponse: function (body) {
                try {
                    return JSON.parse(body);
                }
                catch (e) {
                    console.error('Student Alert Transform Error:', e.message);
                    return {};
                }
            }
        }
    });

    function getStudentAlerts(districtId, studentId, ast) {
        var params = {
            districtId: districtId,
            studentId: studentId,
            ast: ast
        };

        var resource = StudentAlerts.get(params);
        cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise;
    }
}]);
